import script from "./RecoveryGoalType.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryGoalType.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryGoalType.vue?vue&type=style&index=0&id=f30f7da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f30f7da2"]])

export default __exports__